import { atom } from "recoil";

export const mainSelectedTab = atom({
  key: "mainSelectedTab",
  default: 0,
});

export const selectedTab = atom({
  key: "selectedTab",
  default: 0,
});

export const officeSelectedTab = atom({
  key: "officeSelectedTab",
  default: 0,
});
